import clsx from 'clsx';

import { CoinThreshold } from '@/types';
import { addCommas } from '@/utils';

export const ProgressTip = ({ 
	currencyName,
	threshold 
}: { 
	currencyName: string,
	threshold: CoinThreshold 
}) => {
	return (
		<div 
			className={clsx('shop-coin-progress-tip', {
				'shop-coin-progress-tip--left': threshold.ThresholdId <= 3,
				'shop-coin-progress-tip--right': threshold.ThresholdId > 3
			})}
		>
			<div className="shop-coin-progress-tip__content">
				<span className="shop-coin-progress-tip__text">
					{currencyName} {addCommas(Math.round(threshold.RedeemablePrice * 100) / 100)}
				</span>
			</div>
		</div>
	);
};